<template>
  <UIInputSelect v-model="actionSign" :size :data :disabled />
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount } from 'vue'

import { InputSize } from '@types'
import { TaggingRuleAction } from '../utils/types'

import { UIInputSelect } from '@ui/fields'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<TaggingRuleAction>({
  required: true,
})

const data = [
  { value: 'positive', label: 'Positive' },
  { value: 'negative', label: 'Negative' },
  { value: 'flip sign', label: 'Flip Sign' },
]

const size = inject<InputSize>('size')

const actionSign = computed({
  get() {
    return modelValue.value.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value: value || '',
    }
  },
})

onBeforeMount(() => {
  if (actionSign.value !== undefined) return
  actionSign.value = ''
})
</script>
